export default __webpack_public_path__ + "assets/images/9df324f24404db72dec205b2553ecbed.png";